// Tipos de acción del módulo "Iniciativas de IA" (spec 008, Incremento 1: Registro). Molde:
// redux/retroBoard/retroBoardTypes.js (LOADING_X/LOAD_X/ERROR_X).

export const LOADING_INICIATIVAS_IA = "LOADING_INICIATIVAS_IA";
export const LOAD_INICIATIVAS_IA = "LOAD_INICIATIVAS_IA";
export const ERROR_INICIATIVAS_IA = "ERROR_INICIATIVAS_IA";

export const LOADING_INICIATIVAS_IA_CATALOGOS = "LOADING_INICIATIVAS_IA_CATALOGOS";
export const LOAD_INICIATIVAS_IA_CATALOGOS = "LOAD_INICIATIVAS_IA_CATALOGOS";
export const ERROR_INICIATIVAS_IA_CATALOGOS = "ERROR_INICIATIVAS_IA_CATALOGOS";

export const LOADING_INICIATIVAS_IA_KPI = "LOADING_INICIATIVAS_IA_KPI";
export const LOAD_INICIATIVAS_IA_KPI = "LOAD_INICIATIVAS_IA_KPI";
export const ERROR_INICIATIVAS_IA_KPI = "ERROR_INICIATIVAS_IA_KPI";

// Incrementos 2-3 (plan.md §14.2, RF-29/RF-30).
export const LOADING_INICIATIVAS_IA_CHAMPIONS = "LOADING_INICIATIVAS_IA_CHAMPIONS";
export const LOAD_INICIATIVAS_IA_CHAMPIONS = "LOAD_INICIATIVAS_IA_CHAMPIONS";
export const ERROR_INICIATIVAS_IA_CHAMPIONS = "ERROR_INICIATIVAS_IA_CHAMPIONS";
